// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
.home-container {
  text-align: center;
  min-height: calc(100vh - 60px);
  overflow: auto;
  position: relative;
  overflow-x: hidden;
  padding-top: 60px;
  background: linear-gradient(#eb6823, #000000);
}

.home-title {
  font-size: 25px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 50px;
  color: white;
}

.graf-bg-container {
  width: 100%;
  height: 310px;
  overflow: hidden;
  perspective: 2000px;
  opacity: 0.7;
}

.graf-layout {
  height: 100%;
  margin: auto;
  position: relative;
  perspective: 2000px;
}

.graf-circle:first-child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateY(1000deg) rotateX(1000deg)
    rotate(0deg);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid #2098f3;
  animation: scaleOne 5.5s infinite alternate linear;
  opacity: 0;
}

@keyframes scaleOne {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateY(180deg) rotateX(90deg)
      rotate(1000deg);
    opacity: 0;
  }
}

.graf-circle:nth-child(2) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(135deg) rotateY(135deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #ffa20a;
  border-left: none;
  border-top: none;
  animation: scaleTwo 5s infinite alternate linear;
}

@keyframes scaleTwo {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(135deg) rotateY(135deg)
      rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(3) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(45deg) rotateY(45deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #ec412c;
  border-bottom: none;
  border-left: none;
  animation: scaleThree 4.5s infinite alternate linear;
}

@keyframes scaleThree {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(45deg) rotateY(45deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(4) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(45deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #fcbd00;
  border-top: none;
  border-right: none;
  animation: scaleFour 4s infinite alternate linear;
}

@keyframes scaleFour {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(45deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(5) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(135deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #2da94f;
  border-bottom: none;
  border-left: none;
  animation: scaleFive 3.5s infinite alternate linear;
}

@keyframes scaleFive {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(135deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(6) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(100deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 15px solid #f57700;
  border-bottom: none;
  border-right: none;
  animation: scaleSix 3s infinite alternate linear;
}

@keyframes scaleSix {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(100deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(7) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateY(-105deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 10px solid #2098f3;
  border-bottom: none;
  border-left: none;
  animation: scaleSeven 2.5s infinite alternate linear;
}

@keyframes scaleSeven {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateY(-105deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(8) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateY(45deg) rotateX(45deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #30bbb0;
  border-bottom: none;
  border-left: none;
  animation: scaleEight 2s infinite alternate linear;
}

@keyframes scaleEight {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateY(45deg) rotateX(45deg) rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(9) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateY(135deg) rotateX(135deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #ff453c;
  border-bottom: none;
  border-right: none;
  animation: scaleNine 1.5s infinite alternate linear;
}

@keyframes scaleNine {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateY(135deg) rotateX(135deg)
      rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(10) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateY(113deg) rotateX(115deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #2098f3;
  border-bottom: none;
  border-right: none;
  animation: scaleTen 3s infinite alternate linear;
}

@keyframes scaleTen {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateY(113deg) rotateX(115deg)
      rotate(1turn);
    opacity: 0;
  }
}

.graf-circle:nth-child(11) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotateX(-45deg) rotateY(-45deg) rotate(0deg);
  width: 310px;
  height: 310px;
  border-radius: 50%;
  border: 5px solid #2098f3;
  border-bottom: none;
  border-right: none;
  animation: scaleEleven 2s infinite alternate linear;
}

@keyframes scaleEleven {
  to {
    border-radius: 50%;
    transform: translate(-50%, -50%) rotateX(-45deg) rotateY(-45deg)
      rotate(1turn);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/home/Home.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;AACF;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT;gBACc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB;qBACiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6EAA6E;EAC7E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;IAClB;mBACe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE;IACE,kBAAkB;IAClB,4EAA4E;IAC5E,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4DAA4D;EAC5D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,kBAAkB;IAClB,6DAA6D;IAC7D,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE;IACE,kBAAkB;IAClB,8DAA8D;IAC9D,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;IAClB,8DAA8D;IAC9D,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8DAA8D;EAC9D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE;IACE,kBAAkB;IAClB,+DAA+D;IAC/D,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE;IACE,kBAAkB;IAClB,4EAA4E;IAC5E,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6EAA6E;EAC7E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE;IACE,kBAAkB;IAClB;mBACe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6EAA6E;EAC7E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;IAClB;mBACe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,6EAA6E;EAC7E,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE;IACE,kBAAkB;IAClB;mBACe;IACf,UAAU;EACZ;AACF","sourcesContent":["/*\r\n Copyright 2024 European Commission\r\n\r\n Licensed under the Apache License, Version 2.0 (the \"License\");\r\n you may not use this file except in compliance with the License.\r\n You may obtain a copy of the License at\r\n\r\n      https://www.apache.org/licenses/LICENSE-2.0\r\n\r\n Unless required by applicable law or agreed to in writing, software\r\n distributed under the License is distributed on an \"AS IS\" BASIS,\r\n WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n See the License for the specific language governing permissions and\r\n limitations under the License.\r\n */\r\n.home-container {\r\n  text-align: center;\r\n  min-height: calc(100vh - 60px);\r\n  overflow: auto;\r\n  position: relative;\r\n  overflow-x: hidden;\r\n  padding-top: 60px;\r\n  background: linear-gradient(#eb6823, #000000);\r\n}\r\n\r\n.home-title {\r\n  font-size: 25px;\r\n  font-weight: 400;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  margin-top: 50px;\r\n  color: white;\r\n}\r\n\r\n.graf-bg-container {\r\n  width: 100%;\r\n  height: 310px;\r\n  overflow: hidden;\r\n  perspective: 2000px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.graf-layout {\r\n  height: 100%;\r\n  margin: auto;\r\n  position: relative;\r\n  perspective: 2000px;\r\n}\r\n\r\n.graf-circle:first-child {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateY(1000deg) rotateX(1000deg)\r\n    rotate(0deg);\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  border: 5px solid #2098f3;\r\n  animation: scaleOne 5.5s infinite alternate linear;\r\n  opacity: 0;\r\n}\r\n\r\n@keyframes scaleOne {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateY(180deg) rotateX(90deg)\r\n      rotate(1000deg);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(2) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(135deg) rotateY(135deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #ffa20a;\r\n  border-left: none;\r\n  border-top: none;\r\n  animation: scaleTwo 5s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleTwo {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(135deg) rotateY(135deg)\r\n      rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(3) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(45deg) rotateY(45deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #ec412c;\r\n  border-bottom: none;\r\n  border-left: none;\r\n  animation: scaleThree 4.5s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleThree {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(45deg) rotateY(45deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(4) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(45deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #fcbd00;\r\n  border-top: none;\r\n  border-right: none;\r\n  animation: scaleFour 4s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleFour {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(45deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(5) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(135deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #2da94f;\r\n  border-bottom: none;\r\n  border-left: none;\r\n  animation: scaleFive 3.5s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleFive {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(135deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(6) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(100deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 15px solid #f57700;\r\n  border-bottom: none;\r\n  border-right: none;\r\n  animation: scaleSix 3s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleSix {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(100deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(7) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateY(-105deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 10px solid #2098f3;\r\n  border-bottom: none;\r\n  border-left: none;\r\n  animation: scaleSeven 2.5s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleSeven {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateY(-105deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(8) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateY(45deg) rotateX(45deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #30bbb0;\r\n  border-bottom: none;\r\n  border-left: none;\r\n  animation: scaleEight 2s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleEight {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateY(45deg) rotateX(45deg) rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(9) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateY(135deg) rotateX(135deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #ff453c;\r\n  border-bottom: none;\r\n  border-right: none;\r\n  animation: scaleNine 1.5s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleNine {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateY(135deg) rotateX(135deg)\r\n      rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(10) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateY(113deg) rotateX(115deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #2098f3;\r\n  border-bottom: none;\r\n  border-right: none;\r\n  animation: scaleTen 3s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleTen {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateY(113deg) rotateX(115deg)\r\n      rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.graf-circle:nth-child(11) {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotateX(-45deg) rotateY(-45deg) rotate(0deg);\r\n  width: 310px;\r\n  height: 310px;\r\n  border-radius: 50%;\r\n  border: 5px solid #2098f3;\r\n  border-bottom: none;\r\n  border-right: none;\r\n  animation: scaleEleven 2s infinite alternate linear;\r\n}\r\n\r\n@keyframes scaleEleven {\r\n  to {\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) rotateX(-45deg) rotateY(-45deg)\r\n      rotate(1turn);\r\n    opacity: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
